export default "/storefront/client/images/live-event-trme-banner.png";